import { render, staticRenderFns } from "./PlatformExportFilterComponent.vue?vue&type=template&id=28258c14&"
import script from "./PlatformExportFilterComponent.vue?vue&type=script&lang=js&"
export * from "./PlatformExportFilterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports